module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAA9klEQVQ4ja2TvWoCQRRGv9VgkUYfwi6VNoGUsU7jzzMlnaWllRBSWlhFSd4hlYW2woKgBIuIHBkYzWSZ2Z2FHFjYgZlz79x7R/8OUPTVgU9gDzyZvV4iRM/88gM8lhXdAi9AA3h3ZGkZUc05PLOyhV0vY0VGMuUvUyt7BZoxoirwhp/xZV+RqAJMApId0I4RJcAoR3LvZp4nGgYkB9PubB1DolZAYmam4+uqS8X573n8R0l9SXN/eH9GH5lMTsAgb9pDotQKvu2cPBQ9G5fEEXUlrSV92SsVkiTX47rJ1OgushIbSSbwwXe1VaBrPrbmqUQGLYGkM1GXTkNQaD0DAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/subDevice/son_btn_edit.png
// module id = g5Au
// module chunks = 4